module.exports = __webpack_public_path__ + "img/logo_inline_black.4e43cb7f.svg";